export interface HotItem {
  id: number;
  tag: string;
  title: string;
  excerpt: string;
  image: string;
  time: string;
  views: string;
  comments: string;
  hot: number;
}

export const hotFeed: HotItem[] = [
  {
    id: 1,
    tag: "剧组路透",
    title: "古装新剧片场路透流出，男女主同框氛围感拉满",
    excerpt:
      "今日有路人晒出某古装剧组同框路透，两人一白一青的戏服配色意外搭调，现场氛围感十足。吃瓜群众纷纷蹲一个官方定妆照，期待度直接拉满。",
    image:
      "https://readdy.ai/api/search-image?query=A%20dreamy%20ancient%20chinese%20costume%20drama%20film%20set%20at%20dusk%2C%20two%20actors%20in%20flowing%20white%20and%20mint%20green%20hanfu%20facing%20each%20other%2C%20warm%20orange%20lantern%20light%2C%20soft%20mist%2C%20cinematic%20golden%20hour%2C%20editorial%20style%2C%20high%20detail&width=1200&height=760&seq=hot-01-a&orientation=landscape",
    time: "12 分钟前",
    views: "86.2万",
    comments: "1.4万",
    hot: 98,
  },
  {
    id: 2,
    tag: "综艺现场",
    title: "直播综艺收官夜名场面不断，嘉宾互动笑翻全场",
    excerpt:
      "昨晚收官直播一波三折，游戏环节全员放飞自我，弹幕全程刷屏「太会整活了」。网友直呼希望节目组加更番外，在线等瓜群众已经把续集都安排上了。",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20cheerful%20variety%20show%20live%20stage%20with%20colorful%20confetti%20and%20spotlights%2C%20happy%20cast%20members%20laughing%20together%20on%20sofa%2C%20vibrant%20teal%20and%20coral%20decor%2C%20playful%20energy%2C%20modern%20tv%20studio%2C%20high%20detail&width=1200&height=760&seq=hot-02-b&orientation=landscape",
    time: "34 分钟前",
    views: "52.7万",
    comments: "9600",
    hot: 91,
  },
  {
    id: 3,
    tag: "红毯前线",
    title: "时尚盛典红毯图出炉，这套造型讨论度爆表",
    excerpt:
      "今晚时尚盛典红毯持续更新中，某位演员的复古波纹刘海加高定礼服成为全场焦点。造型师在线解说设计理念，网友们则在评论区吵出了「要不要加披风」的世纪难题。",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20celebrity%20red%20carpet%20gala%20evening%2C%20glamorous%20figure%20in%20flowing%20coral%20gown%20with%20camera%20flashes%2C%20luxurious%20ballroom%20background%2C%20sparkling%20lights%2C%20fashion%20editorial%20photography%2C%20warm%20tones%2C%20high%20detail&width=1200&height=760&seq=hot-03-c&orientation=landscape",
    time: "1 小时前",
    views: "43.5万",
    comments: "6200",
    hot: 84,
  },
  {
    id: 4,
    tag: "音乐现场",
    title: "新歌首唱舞台封神，粉丝应援场外排起长队",
    excerpt:
      "人气歌手新歌线下首唱气氛炸裂，现场声浪一浪高过一浪。散场后大批粉丝在出口久久不散，还有不少路人被路透视频「种草」，直呼要蹲完整版音源。",
    image:
      "https://readdy.ai/api/search-image?query=Energetic%20live%20music%20concert%20night%20stage%2C%20singer%20silhouette%20with%20raised%20hand%20in%20front%20of%20vibrant%20stage%20lights%2C%20crowd%20waving%20light%20sticks%2C%20dynamic%20bokeh%2C%20deep%20green%20and%20amber%20lights%2C%20concert%20photography&width=1200&height=760&seq=hot-04-d&orientation=landscape",
    time: "2 小时前",
    views: "38.1万",
    comments: "5400",
    hot: 78,
  },
  {
    id: 5,
    tag: "片场日记",
    title: "悬疑电影片场拍到神秘道具，编剧回应引脑补",
    excerpt:
      "有网友在片场周边拍到一组神秘道具箱，画面略压抑引发大量讨论。编剧随后在社交平台留下意味深长的一句话，评论区已经开启福尔摩斯式推理接力。",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20mystery%20film%20set%20with%20old%20wooden%20props%20and%20foggy%20night%20atmosphere%2C%20mysterious%20clues%20scattered%20on%20a%20desk%2C%20dim%20teal%20and%20warm%20desk%20lamp%2C%20cinematic%20thriller%20vibe%2C%20dark%20accent%20lighting%2C%20editorial&width=1200&height=760&seq=hot-05-e&orientation=landscape",
    time: "3 小时前",
    views: "29.8万",
    comments: "4700",
    hot: 72,
  },
  {
    id: 6,
    tag: "素人暖闻",
    title: "老街区咖啡店主意外走红，暖心回应刷屏",
    excerpt:
      "一家开在老街区的无名咖啡店因老板超暖的招牌文案走红，网友晒出亲手写的祝福卡片。老板回应「只想让喝咖啡的人开心一点」，暖心故事持续发酵中。",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20neighborhood%20coffee%20shop%20corner%20with%20handwritten%20welcome%20sign%20and%20warm%20lights%2C%20steaming%20coffee%20cup%20on%20wooden%20table%2C%20sunny%20morning%20window%20light%2C%20heartwarming%20ambience%2C%20mint%20green%20and%20cream%20tones%2C%20high%20detail&width=1200&height=760&seq=hot-06-f&orientation=landscape",
    time: "4 小时前",
    views: "24.3万",
    comments: "3800",
    hot: 66,
  },
];

export interface RankItem {
  rank: number;
  title: string;
  tag: string;
  heat: number;
  trend: "up" | "down" | "flat";
}

export const hotRank: RankItem[] = [
  { rank: 1, title: "古装新剧路透同框照疯传，网友喊话快点官宣", tag: "剧组路透", heat: 986.4, trend: "up" },
  { rank: 2, title: "收官直播名场面合集，弹幕至今还在刷屏", tag: "综艺现场", heat: 903.2, trend: "up" },
  { rank: 3, title: "时尚盛典红毯造型图，这套波纹刘海杀疯了", tag: "红毯前线", heat: 811.7, trend: "up" },
  { rank: 4, title: "新歌首唱现场声浪炸裂，蹲完整版音源", tag: "音乐现场", heat: 754.5, trend: "down" },
  { rank: 5, title: "悬疑片场神秘道具曝光，编剧留言引推理", tag: "片场日记", heat: 688.9, trend: "up" },
  { rank: 6, title: "老街区咖啡店主暖心回应持续刷屏", tag: "素人暖闻", heat: 631.3, trend: "flat" },
  { rank: 7, title: "颁奖礼后采被问到黑历史，机智化解获好评", tag: "红毯前线", heat: 587.6, trend: "down" },
  { rank: 8, title: "健身综艺开播，导师阵容官宣即登热榜", tag: "综艺现场", heat: 522.8, trend: "up" },
  { rank: 9, title: "全新音乐厂牌官宣，首支单曲预告藏彩蛋", tag: "音乐现场", heat: 487.1, trend: "up" },
  { rank: 10, title: "探班剧组晒盒饭加餐，网友直呼剧组伙食好", tag: "剧组路透", heat: 443.5, trend: "flat" },
];

export interface FollowUpStory {
  id: number;
  title: string;
  status: string;
  points: string[];
}

export const followUpStories: FollowUpStory[] = [
  {
    id: 1,
    title: "某顶流双剧热播，粉丝在线蹲下一部官宣",
    status: "蹲后续中 · 热度持续",
    points: [
      "上午 10:20 — 官方账号更新倒计时海报，暗示新项目即将揭晓",
      "下午 14:45 — 商务合作方点赞相关动态，被网友扒出蛛丝马迹",
      "刚刚 — 吃瓜群众已挤爆评论区，蹲定妆照与预告片",
    ],
  },
  {
    id: 2,
    title: "收官综艺番外呼声高涨，节目组回应「安排中」",
    status: "有回响 · 大概率成行",
    points: [
      "昨天 21:30 — 官微发文感谢观众，评论区「求番外」突破十万",
      "今天 09:10 — 总导演直播透露有惊喜企划在筹备",
      "最新 — 路透称已在拍摄番外片段，坐等上线",
    ],
  },
  {
    id: 3,
    title: "神秘新厂牌单曲预告藏彩蛋，粉丝逐帧找线索",
    status: "线索收集中 · 持续扒瓜",
    points: [
      "本周三 — 厂牌官宣成立，放出首支概念预告",
      "本周四 — 网友在预告结尾发现倒计时与神秘字母",
      "正在扒 — 字母疑似对应全新企划，等瓜群众聚齐蹲点",
    ],
  },
];

export interface Channel {
  id: number;
  name: string;
  desc: string;
  icon: string;
  items: number;
  color: string;
}

export const channels: Channel[] = [
  { id: 1, name: "剧组路透", desc: "片场街拍 · 定妆照 · 探班动态", icon: "ri-camera-3-line", items: 1286, color: "text-primary-500 bg-primary-50" },
  { id: 2, name: "综艺现场", desc: "收官名场面 · 幕后花絮", icon: "ri-tv-2-line", items: 964, color: "text-secondary-500 bg-secondary-50" },
  { id: 3, name: "红毯前线", desc: "盛典造型 · 时尚话题", icon: "ri-shining-line", items: 731, color: "text-primary-500 bg-primary-50" },
  { id: 4, name: "音乐现场", desc: "新歌首唱 · 演唱会应援", icon: "ri-music-2-line", items: 854, color: "text-accent-600 bg-accent-50" },
  { id: 5, name: "片场日记", desc: "悬疑推理 · 幕后故事", icon: "ri-film-line", items: 512, color: "text-secondary-600 bg-secondary-50" },
  { id: 6, name: "素人暖闻", desc: "暖心故事 · 平凡闪光", icon: "ri-heart-3-line", items: 689, color: "text-accent-600 bg-accent-50" },
  { id: 7, name: "时尚街拍", desc: "机场穿搭 · 潮流单品", icon: "ri-shirt-line", items: 476, color: "text-primary-500 bg-primary-50" },
  { id: 8, name: "八卦盘点", desc: "事件脉络 · 时间线整理", icon: "ri-time-line", items: 388, color: "text-secondary-500 bg-secondary-50" },
];

export interface Testimonial {
  id: number;
  name: string;
  avatar: string;
  role: string;
  text: string;
  tag: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "橘子汽水",
    avatar: "https://readdy.ai/api/search-image?query=Cartoon%20avatar%20of%20a%20happy%20young%20girl%20eating%20watermelon%2C%20soft%20flat%20illustration%2C%20warm%20cream%20background%2C%20cheerful%20and%20cute%2C%20clean%20vector%20style&width=200&height=200&seq=ava-01-w&orientation=squarish",
    role: "打卡 312 天",
    text: "每天下班第一件事就是来吃瓜52打个卡，蹲后续蹲得很有安全感，终于不用在别处猜来猜去。",
    tag: "资深吃瓜人",
  },
  {
    id: 2,
    name: "路过的西瓜",
    avatar: "https://readdy.ai/api/search-image?query=Cartoon%20avatar%20of%20a%20young%20man%20holding%20a%20slice%20of%20watermelon%2C%20flat%20vector%20illustration%2C%20warm%20neutral%20background%2C%20playful%20friendly%20style%2C%20clean&width=200&height=200&seq=ava-02-m&orientation=squarish",
    role: "在线等瓜 180 天",
    text: "脉络整理太清楚了，每次蹲一个后续都有人帮你理时间线，本懒人表示很满意。",
    tag: "排队蹲点",
  },
  {
    id: 3,
    name: "瓜田李下",
    avatar: "https://readdy.ai/api/search-image?query=Cartoon%20avatar%20of%20a%20cheerful%20person%20sitting%20in%20a%20watermelon%20field%2C%20flat%20vector%20style%2C%20soft%20cream%20background%2C%20warm%20and%20friendly%2C%20clean%20illustration&width=200&height=200&seq=ava-03-w&orientation=squarish",
    role: "围观群众 96 天",
    text: "评论区氛围特别好，都是理性吃瓜不乱带节奏，这是我留下来打卡的最大原因。",
    tag: "理性观众",
  },
  {
    id: 4,
    name: "半块西瓜",
    avatar: "https://readdy.ai/api/search-image?query=Cartoon%20avatar%20of%20a%20calm%20young%20person%20wearing%20glasses%20next%20to%20watermelon%2C%20flat%20vector%20illustration%2C%20warm%20background%2C%20thoughtful%20and%20gentle%20style%2C%20clean&width=200&height=200&seq=ava-04-m&orientation=squarish",
    role: "下班找乐 60 天",
    text: "热榜更新很勤，热瓜实时跟进不断线，蹲一个后续的心情终于有人懂。",
    tag: "快乐源泉",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "吃瓜52是什么？",
    a: "吃瓜52是爱吃瓜人群的日常打卡与在线等瓜聚集地。在这里你可以看今天的热瓜排行、蹲一个后续的进展，也可以和同好一起梳理热门事件的脉络与时间线。",
  },
  {
    q: "「蹲一个后续」是什么意思？",
    a: "「蹲一个后续」指在事件暂未完结时持续关注更新。吃瓜52会为热门事件整理进展时间线，从第一手线索到官方回应逐条收录，让你不错过每一个关键节点。",
  },
  {
    q: "吃瓜52的信息来源可靠吗？",
    a: "我们以公开路透、官方发布与多方信源交叉比对为准，区分「实锤」与「待验证」，并在内容上标注来源类型，帮助吃瓜群众理性判断，不做无依据的猜测。",
  },
  {
    q: "我该如何开始日常打卡？",
    a: "每天进入首页查看今日热瓜，浏览热榜与蹲后续专区即可完成打卡；遇到感兴趣的话题欢迎到评论区互动。坚持打卡还能点亮连续天数徽章，记录你的吃瓜日常。",
  },
  {
    q: "怎样才能收到最新动态？",
    a: "在页面底部的订阅表单留下常用邮箱，最新热瓜与后续进展会及时推送到你的邮箱；也可以在评论区参与话题，掌握一手讨论风向。",
  },
];

export interface HotChannel {
  name: string;
  today: number;
  desc: string;
}

export const hotChannelList: HotChannel[] = [
  { name: "剧组路透", today: 128, desc: "今日片场与定妆动态已上新 128 条" },
  { name: "综艺现场", today: 96, desc: "名场面与花絮持续更新 96 条" },
  { name: "红毯前线", today: 73, desc: "盛典造型话题 73 条正热" },
  { name: "蹲后续", today: 158, desc: "有 158 个话题正在等待后续更新" },
];